import {BaseService} from "./BaseService";
import {ApiResponse} from "../../shared/models/ApiResponse";

export class OnOfficeService extends BaseService {


    async getFreeApartments(houseId: number) {
        return new Promise<ApiResponse>((resolve, reject) => {
            fetch('/wp-json/kundenportal/v1/onoffice/get-stammobjekt-free-apartments?id=' + houseId, {
                method: 'GET',
                headers: this.apiHeaders,
            })
                .then(res => this.factoryApiResponse(res)).then((apiResponse: ApiResponse) => {
                if (apiResponse.success) {
                    resolve(apiResponse);
                } else {
                    reject(apiResponse);
                }
            })
                .catch(reason => {
                    reject(reason);
                });
        });
    }


}
